import './Breadcrumbs.scss'

import {EntryData} from '../../types'
import {Icon} from '../ui/Icon'
import {Link} from '../../util/link'
import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'
import {useLanguage} from '../../util/i18n'

const styles = style('breadcrumbs', ['item', 'divider'])

export const Breadcrumbs: React.FC<{
	parents?: Array<EntryData>
	title: string
	padright?: boolean
}> = ({parents, title, padright}) => {
	const language = useLanguage()
	const hasParents = parents && parents.length > 0
	const reversedParents = hasParents && parents.slice().reverse()

	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('row').mod({padright})}>
					<BreadcrumbsItem url={language ? `/${language}` : '/'} title="Home" />
					<BreadcrumbsDivider />
					{hasParents &&
						reversedParents.map((child) => (
							<>
								<BreadcrumbsItem {...child} />
								<BreadcrumbsDivider />
							</>
						))}
					<div className={styles.item()}>
						<p className={styles.item('title')}>{title}</p>
					</div>
				</div>
			</Theme.Container>
		</div>
	)
}

const BreadcrumbsItem: React.FC<{url: string; title: string}> = ({
	url,
	title
}) => {
	if (!url && !title) return null

	return (
		<div className={styles.item()}>
			<Link to={url} exact strict className={styles.item('link')}>
				{title}
			</Link>
		</div>
	)
}

const BreadcrumbsDivider = () => (
	<span className={styles.divider()}>
		<Icon icon="chevronRight" />
	</span>
)
